/**
 * CaptionCues — субтитры ДЛЯ МОНТАЖА: слова с временем → реплики SRT, которые человек
 * импортирует в Premiere Pro или DaVinci Resolve и дальше оформляет у себя.
 *
 * Повод — чат 640 (Ангелина, 20.10.2026): «скачивание субтитров для дальнейшего монтажа …
 * Лично я пользуюсь "single word" … есть много предлогов "с", "в", "по", которые считаются
 * одиночным словом, и премьер их разделяет … будет круто, если предлоги будут идти со словом.
 * Ну ещё это может быть частица "не" или союз "и"» и «если ещё и мат будет цензуриться сразу
 * в субтитрах (в моём случае это звёздочки)». Её готовый файл («Шортс 1.1») — образец: одно
 * слово на реплику, «под рукой», «за хоррор», «у этой», «и дверной», «не нужна» вместе,
 * «на*уй», «пи*ду», «е*ать», «бл*ть».
 *
 *   build(words, opts) → [{start, end, text}]
 *     words  [{text, start, end}] — время ЗВУКА слова (у /auto-captions для GigaAM — после
 *            ProfanityRegions.hitSpan)
 *     opts.layout   'word' | 'line' | 'double'  — как «Single Word / Single Line / Double Line»
 *                    в окне «Create captions» Premiere
 *     opts.maxChars символов в строке (42 — умолчание Premiere)
 *     opts.glue     служебные слова не стоят отдельной репликой (по умолчанию да)
 *     opts.lang     'ru' | 'uk' | 'en' — какие слова служебные
 *     opts.mask     function(text) → text — звёздочка в мате (maskFor() ниже)
 *     opts.noPunct  без знаков препинания (как «Remove Punctuation» в Premiere)
 *     opts.noYo     «е» вместо «ё»
 *     opts.lead     на сколько реплика опережает звук слова (с), по умолчанию LEAD_S
 *   placeOnSound(words, ProfanityRegions, i16, duration) — время CTC → время звука (на месте)
 *   toSrt(cues) → текст файла .srt
 *   maskFor(detector, lang) → function(text) — маска по правилам словаря мата
 */
(function (root) {
    'use strict';

    /* Реплика появляется чуть раньше, чем звучит слово. Замер (корпус её текста, 2 голоса ×
       2 темпа × чисто / фон игры, 878 слов, начало слова — по звуку): без опережения слово
       появлялось позже начала звука больше чем на 50 мс у 38 % слов, с 50 мс — у 14 %,
       с 80 мс — у 5 % (раньше звука больше чем на 250 мс — у 1,3 %), со 120 мс опоздание
       уходит совсем, но половина слов появляется раньше чем за 100 мс. */
    var LEAD_S = 0.08;
    // Пауза, которую реплика не перекрывает: в слитной речи слово висит до следующего,
    // в паузе гаснет через TAIL_S после звука (как у неё: «бл*ть» … пауза … «Зато»).
    var HOLD_GAP_S = 0.30, TAIL_S = 0.12;
    // Реплика строкой рвётся на паузе длиннее этой — новая фраза.
    var LINE_PAUSE_S = 0.80;

    /* Где слово ЗВУЧИТ (placeOnSound). Поиск звука (ProfanityRegions.hitSpan) двигает начало к
       онсету НАЗАД верно; ВПЕРЁД, дальше одного кадра модели (40 мс) от начала записи, — на живой
       речи ошибается. Её запись (41 мин, 4642 слова): тихое слово уезжало на онсет следующего
       («лет [человеку] очень» +0,35 с, «с [этими] козлами» +0,38 с) — одинаковых начал у соседей
       75 против 11 у самого CTC, с пределом 14; машинное ухо (звук открыт с места слова, слышит
       ли GigaAM слово): со сдвинутого начала слово слышно в 42–65 % случаев, с начала записи
       +30 мс — в 72–83 %. На синтетическом корпусе (ровная речь edge-tts, начало по энергии)
       сдвиги вперёд чаще верны: реплика ±100 мс 82,0 → 75,8 % (раньше звука, опозданий так же
       5,9 %) — разменяно сознательно: рано на 0,1 с лучше, чем слово, которого не видно. */
    var SOUND_FWD_MAX_S = 0.04;
    // Знак без букв и цифр («—», «…») не звучит; валюта и проценты после числа — часть числа.
    function isMark(text) { return !/[\p{L}\p{N}₽$€£%‰°]/u.test(String(text || '')); }

    /* words — [{text, start, end}] со временем CTC, меняются на месте; PR — ProfanityRegions;
       i16 — звук 16 кГц; duration — длина (с). → сколько слов сдвинуто больше чем на 30 мс. */
    function placeOnSound(words, PR, i16, duration) {
        var speech = [];
        for (var i = 0; i < words.length; i++) if (!isMark(words[i].text)) speech.push(words[i]);
        if (!speech.length) return 0;
        // знаки — не соседи: их «время» сужало окно поиска звука у слова рядом
        var ctx = { words: speech, audio: PR.audio(i16), duration: duration || (i16.length / 16000) };
        var spans = [];
        for (var j = 0; j < speech.length; j++) spans.push(PR.hitSpan(ctx, j));   // все — по времени CTC
        var moved = 0, prevStart = -1;
        for (var k = 0; k < speech.length; k++) {
            var sp = spans[k], w = speech[k];
            if (!sp || !isFinite(sp.start) || !isFinite(sp.end)) continue;
            var st = Math.max(Math.min(sp.start, w.start + SOUND_FWD_MAX_S), prevStart + 0.01);
            if (Math.abs(st - w.start) > 0.03) moved++;
            w.start = st; w.end = Math.max(sp.end, st + 0.04); prevStart = st;
        }
        // конец слова не заходит на начало следующего
        for (var m = 0; m + 1 < speech.length; m++) if (speech[m].end > speech[m + 1].start) speech[m].end = speech[m + 1].start;
        // знак — в начало следующего слова, в хвосте — в конец предыдущего
        var after = null;
        for (var n = words.length - 1; n >= 0; n--) {
            if (!isMark(words[n].text)) { after = words[n]; continue; }
            var t = after ? after.start : null;
            for (var p = n - 1; t === null && p >= 0; p--) if (!isMark(words[p].text)) t = words[p].end;
            if (t !== null) { words[n].start = t; words[n].end = t; }
        }
        return moved;
    }

    /* Знак отдельной репликой не бывает: по одному слову он уходит, в строке встаёт перед
       следующим словом («— Да, очень смешно»). Слова на входе не меняются. */
    function foldMarks(words, layout) {
        var out = [], carry = '';
        for (var i = 0; i < words.length; i++) {
            var w = words[i], t = String(w.text).trim();
            if (isMark(t)) { if (layout !== 'word') carry = carry ? carry + ' ' + t : t; continue; }
            out.push(carry ? { text: carry + ' ' + t, start: w.start, end: w.end } : w);
            carry = '';
        }
        if (carry && out.length) {
            var last = out[out.length - 1];
            out[out.length - 1] = { text: last.text + ' ' + carry, start: last.start, end: last.end };
        }
        return out;
    }

    /* Служебные слова. Проклитики (предлог, союз, отрицание) читаются со СЛЕДУЮЩИМ словом —
       и в русской вёрстке висячий предлог не оставляют; энклитики — с предыдущим. Списки
       короткие намеренно: «да» — и «да», и «да» (союз), «надо» — и предлог, и глагол;
       такие остаются отдельными. */
    var CLITICS_BEFORE = {
        ru: ['в', 'во', 'с', 'со', 'к', 'ко', 'у', 'о', 'об', 'обо', 'от', 'ото', 'до', 'по', 'за', 'из', 'изо',
             'на', 'над', 'под', 'подо', 'при', 'про', 'без', 'безо', 'для', 'из-за', 'из-под', 'перед', 'через',
             'и', 'а', 'но', 'или', 'не', 'ни'],
        uk: ['в', 'у', 'з', 'із', 'зі', 'зо', 'к', 'до', 'на', 'над', 'під', 'по', 'при', 'про', 'для', 'без', 'від',
             'за', 'через', 'перед', 'і', 'й', 'та', 'а', 'але', 'чи', 'не', 'ні'],
        en: ['a', 'an', 'the']
    };
    var CLITICS_AFTER = {
        ru: ['же', 'ж', 'ли', 'ль', 'бы'],
        uk: ['ж', 'же', 'б', 'би'],
        en: []
    };
    function setOf(list) { var o = {}; for (var i = 0; i < list.length; i++) o[list[i]] = 1; return o; }
    var PRO_SET = {}, ENC_SET = {};
    for (var k in CLITICS_BEFORE) { PRO_SET[k] = setOf(CLITICS_BEFORE[k]); ENC_SET[k] = setOf(CLITICS_AFTER[k] || []); }

    function bare(text) {
        return String(text || '').toLowerCase().replace(/ё/g, 'е').replace(/^[^a-zа-яіїєґ0-9-]+|[^a-zа-яіїєґ0-9-]+$/gi, '');
    }
    // Знак после слова, на котором фраза кончается: служебное слово через него не тянется.
    function endsPhrase(text) { return /[.!?…,:;»")\]]\s*$/.test(String(text || '')); }
    function endsSentence(text) { return /[.!?…]\s*["»)]*\s*$/.test(String(text || '')); }

    /* Слова → единицы: каждое служебное слово срастается с соседним. Цепочка «и не знаю»
       — одна единица. */
    function glueUnits(words, lang) {
        var pro = PRO_SET[lang] || {}, enc = ENC_SET[lang] || {};
        var units = [], pending = [];
        for (var i = 0; i < words.length; i++) {
            var w = words[i];
            if (!w || !String(w.text || '').trim()) continue;
            var b = bare(w.text);
            var last = units[units.length - 1];
            /* Число, записанное группами («150 000 ₽» — так e2e-модель пишет «сто пятьдесят
               тысяч рублей»), — одна реплика: «000» и «₽» отдельными репликами — мусор. */
            if (last && !pending.length) {
                var lw = last.words[last.words.length - 1].text;
                if ((/^\d{3}([.,!?…]*)$/.test(w.text) && /\d$/.test(lw)) || (/^[₽$€£%‰°]+[.,!?…]*$/.test(String(w.text).trim()) && /\d$/.test(lw))) {
                    last.words.push(w); continue;
                }
            }
            // энклитика — к предыдущему слову, если её не отделяет конец фразы
            if (enc[b] && !pending.length && last && !endsPhrase(last.words[last.words.length - 1].text)) {
                last.words.push(w); continue;
            }
            pending.push(w);
            if (pro[b] && !endsPhrase(w.text) && i < words.length - 1) continue;   // ждёт следующее слово
            units.push({ words: pending });
            pending = [];
        }
        if (pending.length) units.push({ words: pending });
        return units;
    }

    function unitText(u, opts) {
        var t = u.words.map(function (w) { return String(w.text || '').trim(); }).filter(Boolean).join(' ');
        if (opts.mask) t = opts.mask(t);
        if (opts.noPunct) t = stripPunct(t);
        // «ё» → «е»: так пишут в субтитрах многие, и так она правит руками (чат 640, 22.10)
        if (opts.noYo) t = t.replace(/ё/g, 'е').replace(/Ё/g, 'Е');
        return t;
    }
    // Как «Remove Punctuation»: знаки по краям слов уходят, дефис и апостроф внутри слова остаются.
    function stripPunct(t) {
        return String(t).split(/\s+/).map(function (x) {
            return x.replace(/^[^\p{L}\p{N}*]+|[^\p{L}\p{N}*]+$/gu, '');
        }).filter(Boolean).join(' ');
    }

    function finishTimes(cues, units, lead) {
        for (var i = 0; i < cues.length; i++) {
            var c = cues[i];
            c.start = Math.max(0, c.soundStart - lead, i ? cues[i - 1].start + 0.02 : 0);
        }
        for (var j = 0; j < cues.length; j++) {
            var cj = cues[j], nx = cues[j + 1];
            var end = cj.soundEnd + TAIL_S;
            if (nx && nx.soundStart - cj.soundEnd <= HOLD_GAP_S) end = nx.start;
            // Наименьшая длина реплики не заходит на следующую: пересекающиеся реплики Premiere
            // раскладывает на вторую дорожку (первая выгрузка её записи: 2,000 при конце 2,020).
            cj.end = nx ? Math.min(Math.max(end, cj.start + 0.04), nx.start) : Math.max(end, cj.start + 0.04);
        }
        return cues.map(function (c) { return { start: round3(c.start), end: round3(c.end), text: c.text }; });
    }
    function round3(x) { return Math.round(x * 1000) / 1000; }

    function build(words, opts) {
        opts = opts || {};
        var lang = PRO_SET[opts.lang] ? opts.lang : 'ru';
        var layout = opts.layout === 'line' || opts.layout === 'double' ? opts.layout : 'word';
        var maxChars = Math.max(10, Math.min(120, +opts.maxChars || 42));
        var lead = typeof opts.lead === 'number' ? Math.max(0, opts.lead) : LEAD_S;
        var clean = foldMarks((words || []).filter(function (w) { return w && !w.isEmoji && !w.isSoundCue && String(w.text || '').trim() && isFinite(w.start) && isFinite(w.end); }), layout);
        var units = opts.glue === false
            ? clean.map(function (w) { return { words: [w] }; })
            : glueUnits(clean, lang);
        var cues = [];
        if (layout === 'word') {
            for (var i = 0; i < units.length; i++) {
                var u = units[i];
                cues.push({ soundStart: u.words[0].start, soundEnd: u.words[u.words.length - 1].end, text: unitText(u, opts) });
            }
        } else {
            var lines = layout === 'double' ? 2 : 1;
            var cur = null;
            for (var j = 0; j < units.length; j++) {
                var uj = units[j], txt = unitText(uj, opts);
                var prevUnit = units[j - 1];
                var pause = prevUnit ? uj.words[0].start - prevUnit.words[prevUnit.words.length - 1].end : 0;
                var fits = cur && fitsLines(cur.parts.concat([txt]), maxChars, lines);
                var brk = !cur || !fits || pause > LINE_PAUSE_S || (prevUnit && endsSentence(prevUnit.words[prevUnit.words.length - 1].text));
                if (brk) {
                    if (cur) cues.push(closeLine(cur, maxChars, lines));
                    cur = { parts: [txt], soundStart: uj.words[0].start, soundEnd: uj.words[uj.words.length - 1].end };
                } else {
                    cur.parts.push(txt); cur.soundEnd = uj.words[uj.words.length - 1].end;
                }
            }
            if (cur) cues.push(closeLine(cur, maxChars, lines));
        }
        return finishTimes(cues.filter(function (c) { return c.text; }), units, lead);
    }

    // Влезают ли части в N строк по maxChars (части не рвутся: единица — неделимая)
    function fitsLines(parts, maxChars, lines) { return splitLines(parts, maxChars, lines) !== null; }
    function splitLines(parts, maxChars, lines) {
        var total = parts.join(' ').length;
        if (lines === 1) return total <= maxChars ? [parts.join(' ')] : null;
        if (total <= maxChars) return [parts.join(' ')];
        // две строки: самый ровный разрез
        var best = null;
        for (var i = 1; i < parts.length; i++) {
            var a = parts.slice(0, i).join(' '), b = parts.slice(i).join(' ');
            if (a.length > maxChars || b.length > maxChars) continue;
            var d = Math.abs(a.length - b.length);
            if (!best || d < best.d) best = { d: d, lines: [a, b] };
        }
        return best ? best.lines : null;
    }
    function closeLine(cur, maxChars, lines) {
        var ls = splitLines(cur.parts, maxChars, lines) || [cur.parts.join(' ')];
        return { soundStart: cur.soundStart, soundEnd: cur.soundEnd, text: ls.join('\n') };
    }

    function srtTime(t) {
        var total = Math.max(0, Math.round((isFinite(t) ? t : 0) * 1000));
        var h = Math.floor(total / 3600000), m = Math.floor(total % 3600000 / 60000), s = Math.floor(total % 60000 / 1000), ms = total % 1000;
        return pad(h, 2) + ':' + pad(m, 2) + ':' + pad(s, 2) + ',' + pad(ms, 3);
    }
    function pad(n, w) { var s = String(n); while (s.length < w) s = '0' + s; return s; }
    function toSrt(cues) {
        var out = '';
        for (var i = 0; i < cues.length; i++) out += (i + 1) + '\n' + srtTime(cues[i].start) + ' --> ' + srtTime(cues[i].end) + '\n' + cues[i].text + '\n\n';
        return out;
    }

    /* Маска мата: звёздочка на месте ОДНОЙ буквы корня — слово читается, но не написано
       (как у неё: на*уй, пи*ду, е*ать, бл*ть, бл*). Какое слово — решает словарь
       (ProfanityDetector, тот же, что у /profanity-remover); какая буква — семья правила.
       Незнакомая семья — средняя буква. */
    var ROOT_LETTER = {
        'ru.huy':   /х(?=[уy])/,
        'ru.pizd':  /(?:пи|пе)([зс])(?=[дж])/,
        'ru.eb':    /[её](б)/,
        'ru.blyad': /бл([яеиь])/
    };
    function maskWord(word, ruleId) {
        var w = String(word || ''), low = w.toLowerCase().replace(/ё/g, 'е');
        var re = ROOT_LETTER[ruleId], idx = -1;
        if (re) {
            var m = re.exec(low);      // lowercase and ё→е keep every index in place
            if (m) idx = m[1] !== undefined ? m.index + m[0].lastIndexOf(m[1]) : m.index;
        }
        var letters = [];
        for (var i = 0; i < w.length; i++) if (/\p{L}/u.test(w.charAt(i))) letters.push(i);
        if (idx < 0 || !/\p{L}/u.test(w.charAt(idx))) {
            if (letters.length < 2) return w;
            idx = letters[Math.floor(letters.length / 2)];
        }
        return w.slice(0, idx) + '*' + w.slice(idx + 1);
    }
    function maskFor(detector, lang) {
        if (!detector || typeof detector.scanToken !== 'function') return null;
        var prefix = (lang || 'ru') + '.';
        return function (text) {
            return String(text).split(/(\s+)/).map(function (tok) {
                if (!tok || /^\s+$/.test(tok)) return tok;
                var hit = null;
                try { hit = detector.scanToken(tok); } catch (e) { hit = null; }
                if (!hit) return tok;
                var rule = hit.ruleId && hit.ruleId.indexOf(prefix) === 0 ? hit.ruleId : '';
                return maskWord(tok, rule);
            }).join('');
        };
    }

    var api = { build: build, toSrt: toSrt, glueUnits: glueUnits, maskWord: maskWord, maskFor: maskFor, stripPunct: stripPunct,
                placeOnSound: placeOnSound, LEAD_S: LEAD_S, HOLD_GAP_S: HOLD_GAP_S, TAIL_S: TAIL_S,
                SOUND_FWD_MAX_S: SOUND_FWD_MAX_S, PRO: CLITICS_BEFORE, ENC: CLITICS_AFTER };
    root.CaptionCues = api;
})(typeof self !== 'undefined' ? self : globalThis);
